import IntervalType from './intervalType';

export default IntervalType;
